import { DeleteMe} from "./DeleteMe"

export default DeleteMe
